import React from 'react'
import PropTypes from 'prop-types'
import style from './CheckboxButton.less'
import classNames from 'classnames'

const getClassNames = (checked) => (
  classNames({
    [style.main]: true,
    [style.active]: (checked),
  })
)

const CheckboxButton = (props) => (
  <div className={style.wrapper}>
    <button className={getClassNames(props.checked)} onClick={props.onClick}>
      <span>
        {props.children}
      </span>
    </button>
  </div>
)

CheckboxButton.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.string.isRequired,
}

export default CheckboxButton
